import { useNotification } from 'components/Notification'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { disconnectEmailAccount } from 'services/emailAccounts'
import { EMAIL_ACCOUNTS_QUERY_KEY } from '../constants'

const useEmailAccountMutation = ({ customerId }) => {
  const { createNotification } = useNotification()
  const queryClient = useQueryClient()

  const createErrorNotification = err => {
    const detailedErrMessage = err.response?.data?.errors?.[0] || err.message
    createNotification({
      message: `Something went wrong: ${detailedErrMessage}`,
      variant: 'error',
    })
  }

  const disconnect = useMutation({
    mutationFn: disconnectEmailAccount,
    onSuccess: () => {
      createNotification({ message: 'Email account disconnected', variant: 'success' })
      queryClient.invalidateQueries({
        queryKey: [EMAIL_ACCOUNTS_QUERY_KEY, customerId],
      })
    },
    onError: createErrorNotification,
  })

  return { disconnect }
}

export default useEmailAccountMutation
